<template>
    <transition name="fade">
        <div>
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Province<span class="text-danger">*</span></label>
                        <v-select label="province" :options="provinces" :class="{'vs-invalid': $v.form.province_code.$error}"
                        :reduce="province => province.province_code" placeholder="- Select -" :clearable="false" v-model="form.province_code" @input="getCity(form.province_code)" />
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>City/Municipality<span class="text-danger">*</span></label>
                        <v-select label="city" :options="cities" :reduce="city => city.city_code" :class="{'vs-invalid': $v.form.city_code.$error}"
                        placeholder="- Select -" :clearable="false" v-model="form.city_code" @input="getBarangay(form.city_code)" />
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Barangay<span class="text-danger">*</span></label>
                        <v-select label="bname" :options="barangays" :reduce="bname => bname.bcode" :class="{'vs-invalid': $v.form.bcode.$error}"
                        placeholder="- Select -" :clearable="false" v-model="form.bcode" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>House No/Block & Lot/ Building<span class="text-danger">*</span></label>
                        <input class="form-control form-control-sm text-uppercase" v-model="form.bldg"  :class="{'is-invalid': $v.form.bldg.$error}"/>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Street Name/Subdivision</label>
                        <input class="form-control form-control-sm text-uppercase" v-model="form.street_address" :class="{'is-invalid': $v.form.street_address.$error}"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Home Address Ownership<span class="text-danger">*</span></label>
                        <select class="form-control custom-select-sm" v-model="form.add_ship" :class="{'is-invalid': $v.form.add_ship.$error}">
                            <option selected disabled :value='null'>- Select -</option>
                            <option v-for="(item,index) in ownership" :key="index" :value="item.owner_code">{{item.owner_desc}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Length of Stay in Location (Years)<span class="text-danger">*</span></label>
                        <input type="number" class="form-control form-control-sm" v-model="form.len_loc" :class="{'is-invalid': $v.form.len_loc.$error}" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <button class="btn btn-outline-primary" @click="$emit('next', 1)"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                    <button class="btn btn-primary float-right" @click="btnNext()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    // api
    import {
        apiRefCity,
        apiRefBrgy,
        apiRefProvince,
        apiRefOwnership
    } from "@js/api/getReferences";
    import {
        required
    } from "vuelidate/lib/validators";
    export default {
        data() {
            return {
                form: {
                    borrower_id: null,
                    len_loc: null,
                    add_ship: null,
                    bcode: null,
                    street_address: null,
                    bldg: null,
                    city_code: null,
                    province_code: null,
                },
                provinces: [],
                cities: [],
                barangays: [],
                ownership: [],
            }
        },

        validations() {
            return {
                form: {
                    len_loc: {
                        required
                    },
                    add_ship: {
                        required
                    },
                    bcode: {
                        required
                    },
                    street_address: {
                        required
                    },
                    bldg: {
                        required
                    },
                    city_code: {
                        required
                    },
                    province_code: {
                        required
                    },
                }
            }
        },

        created() {
            this.initData();
        },
        methods: {
            btnNext() {
                this.$v.form.$touch();
                if (this.$v.form.$invalid) {
                    const err = {
                        response: {
                            data: {
                                message: "Please complete all required fields",
                            }
                        }
                    };
                    this.$emit('error', err);
                } else {
                    this.postStep2();
                }

            },
            postStep2() {
                Fire.$emit('loader', 1)
                axios
                    .post("/api/sblaf-prereg-post-step2", this.form)
                    .then(res => {
                        Fire.$emit('loader', -1)
                        this.$emit('next', 3);
                    })
                    .catch(err => {
                        this.$emit('error', err);
                        Fire.$emit('loader', -1)
                    });
            },
            async getBarangay(val) {
                Fire.$emit('loader', 1);
                this.form.bcode = '';
                this.barangays = [];
                try {
                    this.barangays = await apiRefBrgy(val);
                    Fire.$emit('loader', -1);
                } catch (err) {
                    this.$emit('error', err);
                    Fire.$emit('loader', -1);
                }
            },
            async getCity(val) {
                Fire.$emit('loader', 1);
                this.form.city_code = '';
                this.form.bcode = '';
                this.cities = [];
                try {
                    this.cities = await apiRefCity(val);
                    Fire.$emit('loader', -1);
                } catch (err) {
                    this.$emit('error', err);
                    Fire.$emit('loader', -1);
                }
            },
            async getStep2() {
                try {
                    const res = await axios.get("/api/sblaf-prereg-step2");
                    return res.data;
                } catch (err) {
                    throw err;
                }
            },
            async initData() {
                Fire.$emit('loader', 1);
                try {
                    this.provinces = await apiRefProvince();
                    this.ownership = await apiRefOwnership();
                    this.form = await this.getStep2();

                    this.cities = await apiRefCity(this.form.province_code);
                    this.barangays = await apiRefBrgy(this.form.city_code);
                    Fire.$emit('loader', -1);
                } catch (err) {
                    this.$emit('error', err);
                    Fire.$emit('loader', -1);
                }
            },
        },
        computed: {}
    }
</script>